(function ($) {
  Drupal.behaviors.textField = {
	    attach: function (context) {
	    		Drupal.behaviors.textFieldCreator(context);
	    }
};

Drupal.behaviors.textFieldCreator = function (context){
	$(".saphTextField", context).each(function (index){
  		//Reading Data
  		var textClass = $(this).data( "text-class" );
  		var textColorClass = $(this).data( "text-color" );
  		var textAlignmentClass = $(this).data( "text-alignment" );
  		var headlineText = $(this).data( "headline-text" );
  		var headlineTextClass = $(this).data( "headline-text-class" );
  		var headlineTextColorClass = $(this).data( "headline-text-color" );
  		var headlineTextAlignmentClass = $(this).data( "headline-text-alignment" );
  		var linkText = $(this).data( "link-text" );
  		var linkURL = $(this).data( "link-url" );

  		//<div class="saphTextField" data-text-class="link-primary" data-text-color="red" data-text-alignment="right" data-headline-text="What is the artist residency?"
  		//	data-headline-text-class="h4" data-headline-text-color="gray" data-headline-text-alignment="center"
  		//	>Shanghai is one of the world's most exciting places for contemporary art and the artists who create it. Workshops, theaters, galleries and museums light up, transforming the city into an avant-garde experiment in imagining the future. The Swatch Art Peace Hotel artist residency invites artists from around the world to apply online for a residency in this extraordinary city. Different forms of art are welcome to the artist residency, to explore the contemporary arts in China's most vibrant city: photography, music, filmmaking, writing, dancing, painting and conceptual art. The applications are reviewed by an international committee whose efforts ensure that a broad range of artistic disciplines, styles and national origins is represented. The selection process aims to integrate artists in a spirit of openness and curiosity about creativity in its diverse forms and contexts.</div>
  		//By default, Paragraph 1 Left Black is used.
  		//For Headlines the H2 Left Black
  		//paragraph left black-color
  		//h2 left black

	    	var isAlreadyModified = $(this).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}

  		if(!textClass){
  			textClass = "paragraph1";
  		}
  		if(!textColorClass){
  			textColorClass = "black";
  		}
  		if(!textAlignmentClass){
  			textAlignmentClass = "left";
  		}
  		if(!headlineTextClass){
  			headlineTextClass = "h2";
  		}
  		if(!headlineTextColorClass){
  			headlineTextColorClass = "black";
  		}
  		if(!headlineTextAlignmentClass){
  			headlineTextAlignmentClass = "left";
  		}

  		var linkContentsHTML = '';
  		if(linkText != null){
  			linkContentsHTML = '<div class="linkButton" data-text="' + linkText + '" data-url="' + linkURL + '" data-position-right="true"\
  			    data-arrow-color="white" data-arrow-background-color="red"\
  			    data-text-class="link-primary" data-text-color="black" data-is-small="true" data-has-margin-top="true">\
  			    </div>';
  		}

	    	$(this).wrapInner('<div class="col-xs-12 col-sm-8 col-sm-offset-2 no-padding-left-right ' + textClass + ' ' + textColorClass + ' ' + textAlignmentClass + '"></div>'); //Creating the text field
	    	if(headlineText){
	    		$(this).prepend('<div class="col-xs-12 col-sm-8 col-sm-offset-2 no-padding-left-right ' + headlineTextClass + ' ' + headlineTextColorClass + ' ' + headlineTextAlignmentClass + '">' + headlineText + '</div>');
	    	}
	    	if(linkText){
	    		$(this).append('<div class="col-xs-12 col-sm-8 col-sm-offset-2 no-padding-left-right"><div class="linkButton" data-text="' + linkText + '" data-url="' + linkURL + '" data-position-right="true"\
	    			    data-arrow-color="white" data-arrow-background-color="red"\
	    			    data-text-class="link-primary" data-text-color="black" data-is-small="true" data-has-margin-top="true">\
	    			    </div></div>');
	    	}
	    	$(this).wrapInner('<div class="row padding-top-30 padding-bottom-30 main-content-offset"></div>');//Single row for the whole contents
	    	Drupal.behaviors.linkButtonCreator($(this));
	    	$(this).data("saph-done",true);
	});


	//text section with collapse handling
	$(".customTextCollapseSection", context).each(function (index){

		//console.log("customTextCollapseSection init!!!");
		var $section = $(this);

		//show detail copy text
		$section.find(".customTextCollapseSectionLinkOpen").click(function(e){
			e.preventDefault();
			$(".customTextCollapseSectionCopy").hide();
			$(".customTextCollapseSectionIntro").show();

			$section.find(".customTextCollapseSectionIntro").hide();
			$section.find(".customTextCollapseSectionCopy").show();

			var p = $section.offset().top > 100 ? $section.offset().top-100 : 0;
			$('body,html').animate({
				scrollTop: p
			},250);
		});

		//hide detail copy text
		$section.find(".customTextCollapseSectionLinkClose").click(function(e){
			e.preventDefault();

			$(".customTextCollapseSectionCopy").hide();
			$(".customTextCollapseSectionIntro").show();

			var p = $section.offset().top > 100 ? $section.offset().top-100 : 0;
			$('body,html').animate({
				scrollTop: p
			},250);
		});

		//go to top of page
		$section.find(".customTextCollapseSectionLinkTop").click(function(e){
			e.preventDefault();
			$('body,html').animate({
				scrollTop: 0
			},250);
		});

	});
  }


  Drupal.behaviors.introTextField = {
	    attach: function (context) {
	    		Drupal.behaviors.introTextFieldCreator(context);
	    }
	};

  Drupal.behaviors.introTextFieldCreator = function (context){
		$(".saphIntroTextField", context).each(function (index){
  		//Reading Data
  		var textClass = $(this).data( "text-class" );
  		var textColorClass = $(this).data( "text-color" );
  		var textAlignmentClass = $(this).data( "text-alignment" );
  		var headlineText = $(this).data( "headline-text" );
  		var headlineTextClass = $(this).data( "headline-text-class" );
  		var headlineTextColorClass = $(this).data( "headline-text-color" );
  		var headlineTextAlignmentClass = $(this).data( "headline-text-alignment" );

  		//<div class="saphTextField" data-text-class="link-primary" data-text-color="red" data-text-alignment="right" data-headline-text="What is the artist residency?"
  		//	data-headline-text-class="h4" data-headline-text-color="gray" data-headline-text-alignment="center"
  		//	>Shanghai is one of the world's most exciting places for contemporary art and the artists who create it. Workshops, theaters, galleries and museums light up, transforming the city into an avant-garde experiment in imagining the future. The Swatch Art Peace Hotel artist residency invites artists from around the world to apply online for a residency in this extraordinary city. Different forms of art are welcome to the artist residency, to explore the contemporary arts in China's most vibrant city: photography, music, filmmaking, writing, dancing, painting and conceptual art. The applications are reviewed by an international committee whose efforts ensure that a broad range of artistic disciplines, styles and national origins is represented. The selection process aims to integrate artists in a spirit of openness and curiosity about creativity in its diverse forms and contexts.</div>
  		//bBy Default H2 Center Black as a  font style .

	    	var isAlreadyModified = $(this).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}

  		if(!textClass){
  			textClass = "h2";
  		}
  		if(!textColorClass){
  			textColorClass = "black";
  		}
  		if(!textAlignmentClass){
  			textAlignmentClass = "center";
  		}
  		if(!headlineTextClass){
  			headlineTextClass = "h2";
  		}
  		if(!headlineTextColorClass){
  			headlineTextColorClass = "black";
  		}
  		if(!headlineTextAlignmentClass){
  			headlineTextAlignmentClass = "center";
  		}

	    	$(this).wrapInner('<div class="col-xs-12 col-sm-10 col-sm-offset-1 no-padding-left-right ' + textClass + ' ' + textColorClass + ' ' + textAlignmentClass + '"></div>'); //Creating the text field
	    	if(headlineText){
	    		$(this).prepend('<div class="col-xs-12 col-sm-10 col-sm-offset-1 no-padding-left-right ' + headlineTextClass + ' ' + headlineTextColorClass + ' ' + headlineTextAlignmentClass + '">' + headlineText + '</div>');
	    	}
	    	$(this).wrapInner('<div class="row padding-top-30 padding-bottom-30 main-content-offset"></div>');//Single row for the whole contents
	    	$(this).data("saph-done",true);
  	});
  }

  Drupal.behaviors.customTextSection = {
	    attach: function (context) {
	    		Drupal.behaviors.customTextSectionCreator(context);
	    }
  };


  Drupal.behaviors.customTextSectionCreator = function (context){
		$(".customTextSection", context).each(function (index){
		var mainContent = $(this);
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}

	    	var classesToClone;
	    	var alignmentStyle;
	    	var colorStyle;
	    	var newDiv;
	    	var contentsOfElement;
	    	var link;

	    	$("h1,h2,h3,h4",mainContent).each(function (index){
	    		//Create element
	    		newDiv = $("<div></div>");
	    		//Copy alignment and color text and classes
	    		$(newDiv).css("text-align",$(this).css("text-align"));
	    		$(newDiv).css("color",$(this).css("color"));
	    		$(newDiv).addClass($(this).attr("class"));
	    		contentsOfElement = $(this).html();
	    		$(newDiv).html(contentsOfElement);
	    		$(this).replaceWith($(newDiv));
	    	});
	    	//Prepare button links
	    	$(".linkButtonRight",mainContent).each(function (index){

	    		contentsOfElement = $(this).text();
	    		link = $(this).attr("href");
	    		target = $(this).data("target");
	    		if(!target){
	    			target = $(this).attr("target");
	    			if(!target){
		    			target = "_self";
		    		}
	    		}

        //Create element
        newDiv = $('<div class="linkButton"></div>');
        newDiv.attr("data-text", contentsOfElement);
        newDiv.attr("data-url", link);
        newDiv.attr("data-target", target);
        newDiv.attr("data-position-right", "true");
        newDiv.attr("data-arrow-color", "white");
        newDiv.attr("data-arrow-background-color", "red");
        newDiv.attr("data-text-class", "link-primary");
        newDiv.attr("data-text-color", "black");
        newDiv.attr("data-is-small", "true");

        $(this).replaceWith($(newDiv));
      });

      //Modify normal links
      $("a",mainContent).each(function (index){
        var innerContent = DOMPurify.sanitize($(this).html()); // Sanitize the inner HTML content
        $(this).html(innerContent);
        $(this).wrapInner('<span class="linkTextSaph black text-decoration-underline" data-text-color="black"></span>');
      });

      $(this).data("saph-done",true);
      Drupal.behaviors.linkButtonCreator($(this));
    });
  }



})(jQuery);
